import { render } from "./PageLayout.vue?vue&type=template&id=7fefd5f9&scoped=true"
const script = {}

import "./PageLayout.vue?vue&type=style&index=0&id=7fefd5f9&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fefd5f9"]])

export default __exports__